export default __webpack_public_path__ + "assets/apple-touch-icon-60x60-8dfdb8c.png";